import { render, staticRenderFns } from "./complexTable.vue?vue&type=template&id=4b80dfcc"
import script from "./complexTable.vue?vue&type=script&lang=js"
export * from "./complexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports